module.exports = __webpack_public_path__ + "d3450562f2a2f82f800fd54fb6f841f1.png";